import qs from "qs";
import { IInvoiceResponse, IPreviewUrlResponse, ISirTableDataResponse, IValidReactivateInvoiceDataResponse } from "../interfaces/invoice";
import authBaseAxios from "../utils/api";

export const InvoiceServices = {
  getAll: (params: any): Promise<IInvoiceResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`invoices?${queryString}`);
  },
  getAllDebug: (params: any): Promise<IInvoiceResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`invoices/list-debug?${queryString}`);
  },
  downloadFile: (invoiceId: number, attachmentId: number, fileType: string = "file"): Promise<Blob> => {
    return authBaseAxios.get(`/invoices/${invoiceId}/download-file/${attachmentId}?fileType=${fileType}`, {
      responseType: 'blob',
    });
  },
  previewUrl: (invoiceId: number, attachmentId: number): Promise<IPreviewUrlResponse> => {
    return authBaseAxios.get(`/invoices/${invoiceId}/preview-url/${attachmentId}`);
  },
  getStatusByFilter: (params: any): Promise<any> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`invoices/status-map?${queryString}`);
  },
  getDropdownByType: (type: string) => {
    return authBaseAxios.get(`invoices/dropdown-data?type=${type}`);
  },
  changeStatusReject: (id: string, text: string, aiLimitation: boolean): Promise<any> => {
    const body = {
      rejectedReason: text,
      aiLimitation
    }
    return authBaseAxios.put(`invoices/${id}/change-status-reject`, body);
  },
  changeStatusReactivate: (id: string): Promise<any> => {
    return authBaseAxios.put(`invoices/${id}/change-status-reactivate`);
  },

  getInvoiceDetail: (id: string): Promise<ISirTableDataResponse> => {
    return authBaseAxios.get(`invoices/${id}`);
  },
  createInvoice: (body: any): Promise<any> => {
    return authBaseAxios.post(`invoices`, body);
  },
  updateInvoiceDetail: (id: string, body:any): Promise<any> => {
    return authBaseAxios.put(`invoices/${id}`,body);
  },
  updateInvoiceFlightDetail: (id: string, body:any): Promise<any> => {
    return authBaseAxios.put(`invoices/flight/${id}`,body);
  },
  validReactivate: (id: string): Promise<IValidReactivateInvoiceDataResponse> => {
    return authBaseAxios.get(`invoices/${id}/can-reactivate`);
  },
  importCsv: (formData: any) => {
    return authBaseAxios.post('/invoices/import-excel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  changeAiLimitation: (id: string, body: any): Promise<any> => {
    return authBaseAxios.put(`invoices/${id}/ai-limitation`, body);
  },
};